// Brand

export const GET_ALL_BRANDS = 'get_all_brands';
export const GET_ALL_BRANDS_SUCCESS = 'get_all_brands_success';
export const ADD_BRAND = 'add_brand';
export const UPDATE_BRAND = 'update_brand';
export const DELETE_BRAND = 'delete_brand';
export const GET_ALL_BRAND_LIST = 'get_all_brand_list';
export const GET_ALL_BRAND_LIST_SUCCESS = 'get_all_brand_list_success';
export const CHECK_BRAND_NAME_AVAILABILITY = 'check_brand_name_availability';
// Category

export const GET_ALL_CATEGORIES = 'get_all_categories';
export const GET_ALL_CATEGORIES_SUCCESS = 'get_all_categories_success';
export const ADD_CATEGORY = 'add_category';
export const UPDATE_CATEGORY = 'update_category';
export const DELETE_CATEGORY = 'delete_category';
export const GET_ALL_CATEGORIES_BY_BRAND = 'get_all_categories_by_brand';
export const GET_ALL_CATEGORIES_BY_BRAND_SUCCESS = 'get_all_categories_by_brand_success';

// SubCategory

export const GET_ALL_SUBCATEGORIES = 'get_all_subcategories';
export const GET_ALL_SUBCATEGORIES_SUCCESS = 'get_all_subcategories_success';
export const ADD_SUBCATEGORY = 'add_subcategory';
export const UPDATE_SUBCATEGORY = 'update_subcategory';
export const DELETE_SUBCATEGORY = 'delete_subcategory';
export const GET_ALL_SUBCATEGORIES_BY_BRAND_AND_CATEGORY= 'get_all_subcategories_by_brand_and_category';
export const GET_ALL_SUBCATEGORIES_BY_BRAND_AND_CATEGORY_SUCCESS = 'get_all_categories_by_brand_and_category_success';
export const CHANGE_NFT_STATUS_OF_SUBCATEGORY = 'change_nft_status_of_subcategory';


